<div class="ag-no-row-container">
    {{params.noRowsMessageFunc()}}
</div>
